import React from 'react';
import { DeliverableStatus } from '@/types/deliverables';
import { cn } from '@/lib/utils';

interface DeliverableStatusBadgeProps {
  status: DeliverableStatus;
  className?: string;
}

export const DeliverableStatusBadge: React.FC<DeliverableStatusBadgeProps> = ({ status, className }) => {
  const getStatusConfig = (status: DeliverableStatus) => {
    switch (status) {
      case 'PENDING':
        return {
          label: 'Pending',
          className: 'bg-gray-100 text-gray-700 border-gray-300'
        };
      case 'IN_PROGRESS':
        return {
          label: 'In Progress',
          className: 'bg-blue-100 text-blue-700 border-blue-300'
        };
      case 'DELIVERED':
        return {
          label: 'Delivered',
          className: 'bg-green-100 text-green-700 border-green-300'
        };
      case 'VERIFIED':
        return {
          label: 'Verified',
          className: 'bg-emerald-100 text-emerald-700 border-emerald-300'
        };
      case 'REJECTED':
        return {
          label: 'Rejected',
          className: 'bg-red-100 text-red-700 border-red-300'
        };
      case 'DELAYED':
        return {
          label: 'Delayed',
          className: 'bg-orange-100 text-orange-700 border-orange-300'
        };
      default:
        return {
          label: status,
          className: 'bg-gray-100 text-gray-700 border-gray-300'
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border',
        config.className,
        className
      )}
    >
      {config.label}
    </span>
  );
};
